import sentinelLogo from '../../../assets/images/SentinelLogo.png';
import { DqLoading } from '../../DqLoading';
import './Cards.css';
import { IonCard, IonCardContent } from '@ionic/react';
import { DqText } from 'src/components/dq-text';

export interface RecentActivityDetailCardProps {
  loading: boolean;
  title: string;
  body: string;
  footer: string;
  onClick: (route?: string) => void;
  linkRoute?: string;
  automationId?: string;
}

export const RecentActivityDetailCard: React.FC<RecentActivityDetailCardProps> = props => {
  return (
    <IonCard
      className="home-card"
      role="button"
      onClick={() => props.onClick(props.linkRoute)}
      data-testid={`recentActivityCard-${props.automationId}`}
    >
      <IonCardContent className="home-card-content">
        {!!props.loading ? (
          <DqLoading img={sentinelLogo} />
        ) : (
          <div className="home-card-body">
            <DqText variant="h3" className="home-card-title">
              {props.title}
            </DqText>
            <DqText className="home-card-count">{props.body}</DqText>
            <DqText variant="body-small">{props.footer}</DqText>
          </div>
        )}
      </IonCardContent>
    </IonCard>
  );
};
